import { render, staticRenderFns } from "./WysiwygEditor.vue?vue&type=template&id=7cedf9be&scoped=true"
import script from "./WysiwygEditor.vue?vue&type=script&lang=ts"
export * from "./WysiwygEditor.vue?vue&type=script&lang=ts"
import style0 from "./WysiwygEditor.vue?vue&type=style&index=0&id=7cedf9be&scoped=true&lang=css"
import style1 from "./WysiwygEditor.vue?vue&type=style&index=1&id=7cedf9be&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cedf9be",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7cedf9be')) {
      api.createRecord('7cedf9be', component.options)
    } else {
      api.reload('7cedf9be', component.options)
    }
    module.hot.accept("./WysiwygEditor.vue?vue&type=template&id=7cedf9be&scoped=true", function () {
      api.rerender('7cedf9be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/shared/ui/forms/wysiwyg/WysiwygEditor.vue"
export default component.exports